import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Analytics } from '@recruitee/analytics';
import { TranslatePipe } from '@recruitee/i18n';
import {
  DropdownItemComponent,
  IconComponent,
  IntegrationItemComponent,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-slack-integration',
  templateUrl: './slack-integration.component.html',
  standalone: true,
  imports: [IntegrationItemComponent, IconComponent, TranslatePipe, DropdownItemComponent],
})
export class SlackIntegrationComponent {
  @Input() public hasSlackIntegrations: boolean;
  @Input() public isSlackIntegrationLoaded: boolean;
  @Output() public edit: EventEmitter<void> = new EventEmitter();
  @Output() public integrate: EventEmitter<void> = new EventEmitter();
  @Output() public disconnect: EventEmitter<void> = new EventEmitter();

  constructor(public analytics: Analytics) {}
}
